export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-amber-900 via-amber-800 to-orange-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/9e0ec1f08df5eac0f8e6ee60a23adb36/71c80160d04a459cf0ff28e8673272c6.png"
                alt="Tello Crafts - Two hands creating a home"
                className="h-16 w-auto"
              />
              <div>
                <div className="text-xl font-bold text-white">Tello Crafts</div>
                <div className="text-sm text-amber-200 flex items-center gap-1">
                  <i className="ri-hand-heart-line"></i>
                  Made by Two Hands, One Home
                </div>
              </div>
            </div>
            <p className="text-sm text-amber-100 leading-relaxed mb-6 max-w-md">
              Every piece we create is handcrafted in our home workshop, where a husband and wife team brings passion, skill, and love to each creation. Our logo's two hands forming a home represents our commitment to quality craftsmanship.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.etsy.com/shop/TelloCrafts"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-amber-700 hover:bg-amber-600 rounded-lg flex items-center justify-center transition-all cursor-pointer"
              >
                <i className="ri-store-2-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base font-bold mb-4 text-amber-200">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer">
                  Home
                </a>
              </li>
              <li>
                <a href="#products" className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer">
                  Collections
                </a>
              </li>
              <li>
                <a href="#gallery" className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer">
                  Gallery
                </a>
              </li>
              <li>
                <a href="#about" className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer">
                  Our Story
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Shop */}
          <div>
            <h3 className="text-base font-bold mb-4 text-amber-200">Shop</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://www.etsy.com/shop/TelloCrafts"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer inline-flex items-center"
                >
                  Etsy Store
                  <i className="ri-external-link-line ml-1 text-xs"></i>
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-amber-100 hover:text-white transition-colors cursor-pointer">
                  Custom Orders
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-amber-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-amber-200">
            © 2024 TelloCrafts LLC. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?origin=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-amber-200 hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
